import React from 'react';
import { ResizeChanges, SetElementSizeAndPosition } from '../resizing/resizeTypes';
import { Point } from '../../../common/maths/geometry/pointTypes';

type RequiredProps = {
    setElementSizeAndPosition: SetElementSizeAndPosition;
};

export default <T extends RequiredProps>(DecoratedComponent: React.ComponentType<T>): React.FC<T> => {
    return (props: T) => {
        const setElementSizeAndPosition = (_: ResizeChanges, position?: Point) => {
            // Size update handled in TableResizeHandlers
            props.setElementSizeAndPosition(null, position);
        };
        return <DecoratedComponent {...props} setElementSizeAndPosition={setElementSizeAndPosition} />;
    };
};
